import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts'
import type { FeatureData } from '../../lib/types'

interface Props {
  data: FeatureData[]
}

const COLORS = ['#6366f1', '#8b5cf6', '#a78bfa', '#c4b5fd', '#ddd6fe', '#ede9fe']

export default function FeatureChart({ data }: Props) {
  const sorted = [...data].sort((a, b) => b.count - a.count)

  if (sorted.length === 0) {
    return <p className="text-text-muted text-sm">No feature data available.</p>
  }

  return (
    <ResponsiveContainer width="100%" height={Math.max(200, sorted.length * 40)}>
      <BarChart data={sorted} layout="vertical" margin={{ top: 5, right: 20, left: 80, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
        <XAxis
          type="number"
          tick={{ fill: 'var(--color-text-secondary)', fontSize: 12 }}
          tickLine={false}
        />
        <YAxis
          dataKey="feature_name"
          type="category"
          tick={{ fill: 'var(--color-text-secondary)', fontSize: 12 }}
          tickLine={false}
          width={75}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: 'var(--color-elevated)',
            border: '1px solid var(--color-surface)',
            borderRadius: 8,
            color: 'var(--color-text-primary)',
          }}
        />
        <Bar dataKey="count" radius={[0, 4, 4, 0]}>
          {sorted.map((_, i) => (
            <Cell key={i} fill={COLORS[i % COLORS.length]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}
